module.exports = __webpack_public_path__ + "static/Ruby-449ee00cc56a87e929269fc4cb683ca1.svg";